export const locale = {
    lang: 'en',
    data: {
        'MAIL_CONFIRM': {
            'TITLE': 'Confirm your email address!',
            'TEXT_1': 'A confirmation e-mail has been sent to ',
            'TEXT_2': 'Check your inbox and click on the "Confirmar mi email" link to confirm your email address.',
            'BACK': 'Go back to login page',
            'VALIDATION': {
                'TITLE': 'Congratulations!',
                'TEXT_1': 'You can start to use your control panel.',
                'TEXT_2': 'Successfully email confirmation.'
            },
            'ERROR': {
                'TITLE': 'Oops!, it seems that an error has occurred.',
                'ERROR_INFO_1': 'Email not found.',
                'ERROR_INFO_2': 'User not found.',
                'ERROR_INFO_3': 'Your data doesn\'t match.',
                'ERROR_INFO_4': 'An error occurred while trying to activate your account, please try again later.',
                'ERROR_INFO_5': 'Try again later.',
                'ERROR_INFO_6': 'Sorry for the inconveniences.',
            }
        }
    }
};
